module.exports = __webpack_public_path__ + "static/humanitarian_objM@2x-caf6e24c594affab1d22a34d0d7737d6.png";